import React from "react";
import { string } from "prop-types";

import "./AIHUBStoryWidget.m.css";

const OPEN_AI_HUB_EVENT = "open:open-aihub";

const AIHUBStoryWidget = ({ customStyleName, storyContentId }) => {
  const handleOpenAiHub = () => {
    if (typeof window === "undefined") {
      return;
    }

    window.dispatchEvent(
      new CustomEvent(OPEN_AI_HUB_EVENT, {
        detail: {
          source: "story_detailed_widget",
          storyContentId,
          linkText: "aihub",
          linkPosition: "storyGenericWidget",
        },
      })
    );
  };

  return (
    <button
      type="button"
      styleName={`aihub-story-widget ${customStyleName}`}
      aria-label="Open AI Hub"
      onClick={handleOpenAiHub}
    >
      <div styleName="content-wrapper">
        <div styleName="content-div">
          <div styleName="aihub-logo-wrapper"></div>
          <div styleName="go-ad-free-text">Everything you need to know about this story</div>
        </div>
        <div styleName="button-wrapper">
          <span styleName="go-ad-free-btn-red">Launch AI Hub</span>
        </div>
      </div>
      <div styleName="aihub-body-widget-summary">
        Summary, key takeaways, timeline, glossary and FAQs - all in one place.
      </div>
    </button>
  );
};

AIHUBStoryWidget.defaultProps = {
  customStyleName: "",
  storyContentId: "",
};

AIHUBStoryWidget.propTypes = {
  customStyleName: string,
  storyContentId: string,
};

export default AIHUBStoryWidget;
